<template>
  <form-label
    :label="label"
    :class-name="formLabelClassName"
  >
    <template #label>
      <slot name="label" />
    </template>
    <template #header>
      <slot name="header" />
    </template>
    <template #body>
      <textarea
        ref="component"
        :value="value"
        :class="className"
        :placeholder="placeholder"
        v-bind="$attrs"
        class="pega-form-item"
        data-test="item"
        @input="update"
      />
    </template>
    <template #error>
      <slot name="error" />
    </template>
  </form-label>
</template>

<script>
import FormLabel from '@/components/atoms/FormLabel'

export default {
  components: {
    FormLabel
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    className: {
      type: [String, Array, Object],
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    formLabelClassName: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  methods: {
    update (e) {
      this.$emit('input', e.target.value)
      this.$emit('change', e.target.value)
    },
    getTextSelectionStart () {
      return this.$refs.component.selectionStart
    }
  }
}
</script>
